/* eslint-disable no-debugger */
import { useState, } from 'react';

import OfficialCompetitionCategoryData from './OfficialCompetitionCategoryData';

const useOfficialCompetitionCategory = () => {
  const [officialCompetitionCategoryState, setOfficialCompetitionCategoryState] = useState(OfficialCompetitionCategoryData.INITIAL_STATE);

  const getOfficialCompetitionCategory = (personId) => {
    return OfficialCompetitionCategoryData.getOfficialCompetitionCategoryData(personId, officialCompetitionCategoryState, setOfficialCompetitionCategoryState);
  };

  const putOfficialCompetitionCategory = (personId, officialCompetitionCategoryObj) => {
    return OfficialCompetitionCategoryData.putOfficialCompetitionCategoryData(personId, officialCompetitionCategoryObj, officialCompetitionCategoryState, setOfficialCompetitionCategoryState);
  };

  return {
    officialCompetitionCategoryState,
    getOfficialCompetitionCategory,
    putOfficialCompetitionCategory
  };  
};
export default useOfficialCompetitionCategory;